import React, { Component } from "react";
import download from 'downloadjs';
import Modal from 'react-modal';
import {useState, useEffect} from 'react';
import api from '../../../config.js';
import './adresses.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaSearch, FaEye, FaArrowLeft, FaArrowRight, FaCog, FaPrint } from 'react-icons/fa';
import { makeSearch, getPermission, showMessageError } from '../../../classes/functions';
import baseUrl from '../../../baseUrl.js';
import ReactTooltip from "react-tooltip";
import axios from 'axios';
import Select from 'react-select';
import TablePagination from '../../../components/TablePagination/index.js';

import { Link } from 'react-router-dom';
import { customStyleSelect } from "../../../classes/consts.js";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '900px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function Adresses(){
  const [list, setList] = useState([]);
  const [listAll, setListAll] = useState([]);
  const [listFinal, setListFinal] = useState([]);
  const [modalPrintTags, setModalPrintTags] = useState(false);
  
  const [termSearch, setTermSearch] = useState('');

  //Paginação
  const [activePage, setActivePage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  const [registerFrom, setRegisterFrom] = useState('');
  const [registerTo, setRegisterTo] = useState('');
  const [itensByPage, setItensByPage] = useState(50);
  const [carrying, setCarrying] = useState(true);

  const [situacao, setSituacao] = useState('');
  const [listSituacoes, setListSituacoes] = useState([]);
  const [de, setDe] = useState('');
  const [ate, setAte] = useState('');

  const [selectedOption, setSelectedOption] = useState([]);
  
  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();

  useEffect(()=> {
    async function loadAdresses(){
      let data = {
        data: {
          situacao: listSituacoes, 
          termSearch: termSearch,
          page: 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/adresses/getSearch", data)
      .then((response) => {
        setList(response.data.dados);
        setTotal(response.data.qtde);
        setListAll(response.data);
        
        setLastPage(response.data.qtde, qtdePage);
        setCarrying(false);
      }).catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
      });
    }

    getData();
    loadAdresses();

    return () => {

    }
  }, []);
  
  function printAdresses (id) {
    setCarrying(true);
    axios.get(
      baseUrl + "api/adresses/print?id=" + id, 
      {responseType: 'blob',
      headers: {
        empresa: localStorage.empresa,
        usuario: localStorage.usuario
      }} 
      
    ).then((response) => { 
      const content = response.headers['content-type'];
      download(response.data, 'etiquetas.pdf', content);
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function openModal () {
    setDe('');
    setAte('');
    
    setModalPrintTags(true);
  }

  function closeModal () {
    setModalPrintTags(false);
  }

  function print () {
    setCarrying(true);
    axios.get(
      baseUrl + "api/adresses/print?de=" + de + "&ate=" + ate, 
      {responseType: 'blob',
      headers: {
        empresa: localStorage.empresa,
        usuario: localStorage.usuario
      }} 
      
    ).then((response) => {      
      const content = response.headers['content-type'];
      download(response.data, 'etiquetas.pdf', content);
      toast.success('Etiquetas impressas com sucesso.');
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }
  
  function search(aux = selectedOption, qtdeItens = qtdePage, term = termSearch) {
    setSelectedOption(aux);
    setTermSearch(term);

    setPage(1);
    setQtdePage(qtdeItens);

    let data = {
      data: {
        situacao: aux, 
        termSearch: term,
        page: page,
        qtdePage: qtdeItens,
      }
    };

    api.post("/api/adresses/getSearch", data)
    .then((response) => {
        setList(response.data.dados);
        setTotal(response.data.qtde);
        setLastPage(response.data.qtde, qtdeItens);
        setListAll(response.data);
        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  async function getData() {
    api.get("/api/adresses/getDataPage")
    .then((response) => {
      var auxSituacoes = [];
      response.data.situacoes.map((element) => {
        auxSituacoes.push({
          value: element.chave, 
          label: element.descricao
        })
      })
      setListSituacoes(auxSituacoes);
      
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Endereços">
          {getPermission('CADASTROS - ENDERECOS - IMPRESSAO ETIQUETA') && <button className="buttonPrint" onClick={openModal}>
            Imprimir
          </button>}
          {getPermission('CADASTROS - ENDERECOS - CADASTRO') && <Link to="/adresses/cadastrar">
            <button className="buttonInsert">
              Cadastrar
            </button> 
          </Link>}
          <select className='selectQtdeItens' value={itensByPage} onChange={ (e) => {setItensByPage(e.target.value);search(listSituacoes, e.target.value);} }>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <input className="inputSearch" type="text" onChange={(e) => {search(listSituacoes, itensByPage, e.target.value)}} placeholder="Pesquisar"/>
          <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">Descrição</th>
                <th scope="col">Endereço</th>
                <th scope="col">Nível</th>
                <th scope="col">Zona de Armazenagem</th>
                <th scope="col">
                  <Select 
                    className="selectMulti"
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    options={listSituacoes} 
                    placeholder="Situação"
                    onChange={e => {setSelectedOption(e);search(e);}}
                    isMulti
                  />
                </th>
                <th scope="col">Armazém</th>
                <th scope="col" className='collumOption'>Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="Descrição">{item.descricao}</td>
                    <td data-label="Endereço">{item.endereco}</td>
                    <td data-label="Endereço">{item.nivel}</td>
                    <td data-label="Zona">{item.zona}</td>
                    <td data-label="Situação">{item.situacao}</td>
                    <td data-label="Armazém">{item.armazem}</td>
                    <td data-label="Opções">
                      {getPermission('CADASTROS - ENDERECOS - CADASTRO') && <Link className="action" to={`/adresses/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} />
                      </Link>}
                      <Link className="action" to={`/adresses/cadastrar/v${item.id}`} >
                        <FaEye color="#000" size={19} />
                      </Link>
                      {getPermission('CADASTROS - ENDERECOS - IMPRESSAO ETIQUETA') && <Link className="action">
                        <FaPrint color="#000" size={17}  onClick={() => printAdresses(item.id)} />
                      </Link>}
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={7}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <TablePagination limitPage={limitPage} setLimitPage={setLimitPage} page={page} pesquisa_status={selectedOption} qtdePage={qtdePage} setCarrying={setCarrying} setList={setList} setPage={setPage} setQtdePage={setQtdePage} setTotal={setTotal} termSearch={termSearch} API="/api/adresses/getSearch" params={{}}/>
      </div>}

      <Modal  
        isOpen={modalPrintTags}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Tags"
        ariaHideApp={false}
      >
        <div className="body-modal">
          <div className="formDiv">
            <div className="divGroup">
              <div className="formDiv">
                <label>De</label><br/>
                <input type="text" placeholder="" value={de} onChange={ (e) => setDe(e.target.value) }/>
              </div>

              <div className="formDiv">
                <label>Até</label><br/>
                <input type="text" placeholder="" value={ate} onChange={ (e) => setAte(e.target.value) }/>
              </div>
            </div>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonSubmit" onClick={print}>Imprimir</button>
            <button type="button" className="buttonCancel" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}